import type { LoadingScreen } from '../ui/types';

export function bindCityMenu(
  doc: Document,
  win: Window,
  screen: LoadingScreen,
  entered: () => boolean,
  suspend: (value: boolean) => void,
  blocked: () => boolean
): { open: () => void; dispose: () => void } {
  let pressed = false;
  const resume = (): void => {
    screen.hide();
    suspend(false);
  };
  const open = (): void => {
    if (screen.isOpen) return;
    suspend(true);
    screen.show(resume);
  };
  const unavailable = (): boolean =>
    !entered() || blocked() || Boolean(doc.querySelector('dialog[open]'));
  const down = (event: KeyboardEvent): void => {
    if (event.code !== 'Escape') return;
    pressed = true;
    if (event.repeat || unavailable()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (screen.isOpen) resume();
    else open();
  };
  const up = (event: KeyboardEvent): void => {
    if (event.code !== 'Escape') return;
    /* Browsers can reserve Escape's keydown for releasing pointer lock. */
    if (!pressed && !screen.isOpen && !unavailable()) open();
    pressed = false;
  };
  win.addEventListener('keydown', down, true);
  win.addEventListener('keyup', up, true);
  return {
    open,
    dispose: () => {
      win.removeEventListener('keydown', down, true);
      win.removeEventListener('keyup', up, true);
    },
  };
}
